import {investments_api} from '@/store/resources'

export default {
    namespaced: true,
    state: {
        assets_list: {
            data: [],
            dirty: false
        },
        grouped_assets_list: {
            data: [],
            dirty: false
        }
    },
    getters: {
        assetSortedGroupsList(state) {
            return [...state.grouped_assets_list.data].map(item => {
                if (item.sort_by === '') {
                    return {...item}
                } else {
                    return {
                        ...item,
                        assets: [...item.assets].sort((a, b) => {
                            let sortField = item.sort_by.replace('-', ''),
                                sortType = item.sort_by.includes('-') ? 'desc' : 'asc';

                            if (['name', 'ticker'].includes(sortField)) {
                                return sortType === 'desc'
                                    ? b[sortField].localeCompare(a[sortField])
                                    : a[sortField].localeCompare(b[sortField]);
                            } else {
                                return sortType === 'desc'
                                    ? b[sortField] - a[sortField]
                                    : a[sortField] - b[sortField];
                            }
                        })
                    }
                }
            });
        },
        assetsGroupsNoCurrencies(state, getters) {
            let groups = getters.assetSortedGroupsList
            return groups.filter(group => group.properties.type !== 4)
        }
    },
    actions: {
        getAssets({commit}, portfolio_id) {
            commit('setAssetsDirty')
            investments_api.assets.get({portfolio_id}).then(res => {
                if (res.body.success) {
                    commit('setAssets', res.body.data.rows)
                }
            });
        },
        getGroupedAssets({commit}, portfolio_id) {
            commit('setGroupsAssetsDirty')
            investments_api.assets_grouped.get({portfolio_id}).then(res => {
                if (res.body.success) {
                    commit('setGroupsAssets', res.body.data.rows)
                }
            });
        },
    },
    mutations: {
        setAssetsDirty(state) {
            state.assets_list.dirty = true;
        },
        setAssets(state, data) {
            state.assets_list.data = data;
            state.assets_list.dirty = false;
        },
        setGroupsAssetsDirty(state) {
            state.grouped_assets_list.dirty = true;
        },
        setGroupsAssets(state, data) {
            state.grouped_assets_list.data = data.sort((a, b) => a.properties.type - b.properties.type).map(item => ({
                ...item,
                sort_by: '',
                assets: item.assets.map(asset => ({
                    ...asset,
                    name: asset.instrument.name,
                    ticker: asset.instrument.ticker,
                }))
            }));
            state.grouped_assets_list.dirty = false;
        },
        setGroupSort(state, {type, sort_by}) {
            let group = state.grouped_assets_list.data.find((group) => group.properties.type === type)
            group.sort_by = group.sort_by === sort_by
                ? `-${sort_by}`
                : group.sort_by === `-${sort_by}`
                    ? ''
                    : sort_by;
        }
    }
}